import * as yup from 'yup';

import actions from '../../../constants/actionTypes';
import request from '../../../utils/request';
import { startAppLoading, stopAppLoading } from '../../../layout/actions';
import { formatDate, isSuccess } from '../../../utils/utils';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import { trans } from '../../../localization/index';

export function handleChangeFilters(name, value) {
  return {
    type: actions.CHANGE_FILTER_REPORT_DISH,
    response: {
      [name]: value,
    },
  };
}

export function getListReportDish() {
  function validate(state, dispatchGeneralError) {
    const { filters } = state;
    const schema = yup.object().shape({
      fromDate: yup
        .date()
        .max(yup.ref('toDate'), trans('from_date_to_date_not_correct'))
        .required(),
      toDate: yup.date().required(),
      restaurant: yup.object().shape({
        value: yup.number().required(),
      }),
    });
    try {
      schema.validateSync(filters);
      return true;
    } catch (err) {
      dispatchGeneralError(err.errors[0]);
      return false;
    }
  }

  function genBody(state) {
    const { filters } = state;
    const { fromDate, toDate, restaurant } = filters;

    const body = {
      from_date: formatDate(fromDate),
      to_date: formatDate(toDate),
    };
    if (restaurant.value) {
      body.restaurant_ids = restaurant.value;
    }
    return body;
  }

  return (dispatch, getState) => {
    const state = getState().report.dish;
    if (!validate(state, error => dispatch(setGeneralError(error)))) {
      return null;
    }
    const body = genBody(state);
    dispatch(startAppLoading());
    return request
      .getMerchant('/api/report/get_by_menu', body)
      .then((response) => {
        if (isSuccess(response)) {
          const {
            dish_reports: itemList = [],
            value_sum_total: valueSumTotal = '',
          } = response.reply;
          dispatch({
            type: actions.RECEIVE_LIST_REPORT_DISH,
            response: {
              itemList,
              totalSize: itemList.length,
              valueSumTotal,
            },
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportDish/actions.js